import { ProjectSetup, UserSession } from '@shared/models';
import { DprDetails } from '@shared/models/dpr';
import { Observable } from 'rxjs';

export abstract class BasePersistenceService {
  // user session

  abstract getUserSession(): Observable<UserSession>;

  // `subprojectId` names the subproject explicitly instead of taking the selected one from the
  // store, which still holds the previous subproject while a switch is landing.
  abstract getProjectSetup(subprojectId?: number): Observable<ProjectSetup>;

  abstract getLastThreeDprs(subprojectId?: number): Observable<DprDetails[]>;
}
